import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Ambulance } from "lucide-react";

export default function Register() {
  const { registerAgency } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ agency_name: "", admin_name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await registerAgency(form);
      nav("/app");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6F8] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-lg border border-slate-200 p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-[#0A192F] flex items-center justify-center">
            <Ambulance className="text-white" size={20} />
          </div>
          <div>
            <div className="font-display font-semibold text-lg">RideWise NEMT</div>
            <div className="text-xs text-slate-500">Create your agency account</div>
          </div>
        </div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.1em] text-[#005E82] mb-4">
          30-day free trial, no card required
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <Field label="Agency name" testId="reg-agency" value={form.agency_name} onChange={update("agency_name")} required />
          <Field label="Your name" testId="reg-name" value={form.admin_name} onChange={update("admin_name")} required />
          <Field label="Work email" testId="reg-email" type="email" value={form.email} onChange={update("email")} required />
          <Field label="Password" testId="reg-password" type="password" value={form.password} onChange={update("password")} required />
          {err && <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-2">{err}</div>}
          <button type="submit" disabled={loading} className="w-full btn-primary" data-testid="register-submit">
            {loading ? "Creating…" : "Create agency"}
          </button>
          <div className="text-xs text-slate-500 text-center">
            After the trial: $39 per driver per month, unlimited vehicles, rides and facility logins. Cancel any time.
          </div>
        </form>
        <div className="mt-4 text-sm text-slate-500 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[#005E82] font-medium hover:underline">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, testId, type = "text", ...rest }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500">{label}</label>
      <input
        data-testid={testId}
        type={type}
        {...rest}
        className="mt-1 w-full text-sm px-3 py-2.5 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300"
      />
    </div>
  );
}
